<template>
  <div class="go-in">
    <div
      class="organizational"
      :style="`height:${pageLoading ? '3rem' : 'auto'};`"
      v-loading="pageLoading"
    >
      <div style="box-sizing: border-box">
        <TitleTips
          :routerList="routerList"
          routeType="/gywm/developmentHistory"
          title="发展历程"
        />
      </div>
      <div
        calss="organitionImg"
        style="
          display: flex;
          justify-content: flex-start;
          margin-bottom: 0.1rem;
        "
      >
        <div style="width: 7rem; font-size: 0.18rem">
          <ul
            class="historyItem"
            v-for="(item, index) in historyData"
            :key="index"
          >
            <li>
              <span>{{ item.dataTime.split('-')[0] + '年' }}</span>
              <div class="leftLine"></div>
              <div v-if="index != historyData.length - 1" class="bottomLine">
                <div class="redHot"></div>
              </div>
            </li>
            <li>
              <div class="workText">
                <p>{{ item.title }}</p>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="item.describe"
                  placement="top"
                >
                  <!-- <el-button>上边</el-button> -->
                  <span class="workText-describe">{{ item.describe }}</span>
                </el-tooltip>
              </div>
              <div class="work-img">
                <img
                  :src="getUrl(item.url)"
                  alt=""
                  style="width: 2.19rem; height: 1.38rem"
                />
              </div>
              <span class="num">{{ item.dataTime.split('-')[1] }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleTips from '../components/TitleTips.vue';
import http from '../utils/http';
import getFileUrl from '../utils/urlHelp';
export default {
  components: {
    TitleTips
  },
  name: 'qualityCommitment',
  data() {
    return {
      pageLoading: false,
      imgUrlBanner: '',
      pageObj: {},
      routerList: [],
      historyData: [
        // {
        //   title:'红星电子工业园落成',
        //   dataTime:'2014年',
        //   url:'',
        //   describe:'红星电子工业园落成，顺利搬迁',
        //   id:'06'
        // },
        // {
        //   title:'向家坝工业园区开工建设',
        //   dataTime:'2010年',
        //   url:'',
        //   describe:'红星电子工业园落成，顺利搬迁',
        //   id:'03'
        // },
        // {
        //   title:'与四川长虹电子集团公司战略重组',
        //   dataTime:'2009年',
        //   url:'',
        //   describe:'公司与四川长虹电子集团公司战略重组，并入四川长虹电子集团旗下的四川电子军工集团',
        //   id:'02'
        // },
      ]
    };
  },
  created() {
    this.pageLoading = true;
    http
      .post('/reception/about/getAllUs', {
        groupType: '108',
        title: '',
        pageNum: 0,
        pageSize: 100
      })
      .then(res => {
        this.historyData = res.rows;
      })
      .finally(() => {
        this.pageLoading = false;
      });
  },
  mounted() {
    this.routerList = this.$route.matched;
  },

  watch: {
    // $route: {
    //   handler: function(val, oldVal){
    //     if(val!=oldVal){
    //     }
    //   },
    //   // 深度观察监听
    //   deep: true
    // }
  },
  methods: {
    getUrl(str) {
      const res = getFileUrl(str);
      return res;
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  .organizational {
    width: 100%;
    box-sizing: border-box;
    padding: 0rem 1rem 0rem 1rem;
    .historyItem {
      position: relative;
      width: 12rem;
      height: 2.5rem;
      margin-top: 0.2rem;
      li:nth-child(1) {
        position: relative;
        width: 1.14rem;
        height: 0.24rem;
        background: #fb0514;
        position: absolute;
        top: 0rem;
        left: 0rem;
        font-size: 18px;
        line-height: 0.24rem;
        font-weight: 700;
        text-align: center;
        color: #fff;
        .leftLine {
          width: 0.74rem;
          height: 1px;
          background: black;
          position: absolute;
          top: 0.12rem;
          left: 1.18rem;
        }
        .bottomLine {
          width: 0.01rem;
          height: 2.25rem;
          background: black;
          position: relative;
          position: absolute;
          top: 0.34rem;
          left: 0.57rem;
          .redHot {
            position: absolute;
            top: 1rem;
            left: -0.06rem;
            width: 0.1rem;
            height: 0.1rem;
            border-radius: 50%;
            border: 0.01rem solid #f2f2f2;
            box-shadow: 0.01rem 0.01rem 0.05rem gray;
            background: #fb0514;
          }
        }
      }
      li:nth-child(2) {
        width: 8.06rem;
        height: 2.26rem;
        background: #f2f2f2;
        position: absolute;
        position: relative;
        top: 0rem;
        left: 2rem;
        display: flex;
        justify-content: space-between;
        .workText {
          width: 5rem;
          box-sizing: border-box;
          // padding-left: 0.2rem;
          // .item{
          //   width:4rem;
          // }
          p {
            height: 0.45rem;
            padding-top: 0.15rem;
            box-sizing: border-box;
            margin: 0.1rem 0rem 0.2rem 0rem;
            padding-left: 0.12rem;
            font-size: 0.24rem;
            font-weight: 600;
            color: #fb0514;
            border-left: 0.08rem solid #fb0514;
          }
          .workText-describe {
            padding-left: 0.18rem;
            font-size: 0.12rem;
            color: #333;
            overflow: hidden; //溢出内容隐藏
            text-overflow: ellipsis; //文本溢出部分用省略号表示
            display: -webkit-box; //特别显示模式
            -webkit-line-clamp: 4; //行数
            line-clamp: 2;
            -webkit-box-orient: vertical; //盒子中内容竖直排列
          }
        }
        .work-img {
          width: 2.19rem;
          height: 1.38rem;
          background: gray;
          margin-right: 0.3rem;
          align-self: center;
        }
        .num {
          font-size: 0.65rem;
          position: absolute;
          right: -0.3rem;
          top: -0.2rem;
          font-weight: 700;
          color: #fb0514;
        }
      }
    }
  }
}
</style>
